import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Rating() {
  const navigate = useNavigate();
  const [ratings, setRatings] = useState({
    experience: 0,
    driver: 0,
    provider: 0
  });
  const [comment, setComment] = useState('');

  const handleSubmit = () => {
    navigate('/orders');
  };

  const RatingStars = ({ value, onChange }: { value: number; onChange: (val: number) => void }) => {
    return (
      <div className="flex gap-2 justify-center">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            onClick={() => onChange(star)}
            className="w-12 h-12 flex items-center justify-center transition-transform active:scale-90"
          >
            <i className={`${star <= value ? 'ri-star-fill' : 'ri-star-line'} text-3xl ${
              star <= value ? 'text-[#FF8F00]' : 'text-gray-300'
            }`}></i>
          </button>
        ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-24" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Top Navigation */}
      <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-[#0D47A1] to-[#1976D2] z-50">
        <div className="px-4 py-4 flex items-center gap-3">
          <button onClick={() => navigate('/tracking')} className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-2xl"></i>
          </button>
          <h1 className="text-white text-lg font-bold">تقييم التجربة</h1>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20 px-4">
        {/* Success Icon */}
        <div className="bg-white rounded-2xl p-8 mb-4 text-center">
          <div className="w-24 h-24 bg-gradient-to-br from-[#4CAF50] to-[#45a049] rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-checkbox-circle-fill text-white text-5xl"></i>
          </div>
          <h2 className="text-[#212121] text-xl font-bold mb-2">تم التسليم بنجاح!</h2>
          <p className="text-gray-600 text-sm">نتمنى أن تكون راضياً عن الخدمة</p>
        </div>

        {/* Experience Rating */}
        <div className="bg-white rounded-2xl p-5 mb-3">
          <h3 className="text-[#212121] font-bold text-center mb-4">كيف كانت تجربتك؟</h3>
          <RatingStars 
            value={ratings.experience} 
            onChange={(val) => setRatings({ ...ratings, experience: val })}
          />
        </div>

        {/* Driver Rating */}
        <div className="bg-white rounded-2xl p-5 mb-3">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-[#0D47A1] to-[#1976D2] rounded-full flex items-center justify-center">
              <i className="ri-user-fill text-white text-xl"></i>
            </div>
            <div>
              <h3 className="text-[#212121] font-bold text-sm">قيّم المندوب</h3>
              <p className="text-gray-500 text-xs">أحمد محمد</p>
            </div>
          </div>
          <RatingStars 
            value={ratings.driver} 
            onChange={(val) => setRatings({ ...ratings, driver: val })}
          />
        </div>

        {/* Provider Rating */}
        <div className="bg-white rounded-2xl p-5 mb-3">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-[#FF8F00] to-[#F57C00] rounded-full flex items-center justify-center">
              <i className="ri-store-2-fill text-white text-xl"></i>
            </div>
            <div>
              <h3 className="text-[#212121] font-bold text-sm">قيّم المتجر</h3>
              <p className="text-gray-500 text-xs">بقالة الخير</p>
            </div>
          </div>
          <RatingStars 
            value={ratings.provider} 
            onChange={(val) => setRatings({ ...ratings, provider: val })}
          />
        </div>

        {/* Comment */}
        <div className="bg-white rounded-2xl p-5">
          <h3 className="text-[#212121] font-bold mb-3">أضف تعليق (اختياري)</h3>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="شاركنا رأيك وملاحظاتك..."
            className="w-full h-32 p-4 bg-[#F6F6F6] rounded-xl text-sm resize-none focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
            maxLength={500}
          ></textarea>
          <div className="text-left mt-2">
            <span className="text-gray-400 text-xs">{comment.length}/500</span>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-50">
        <button
          onClick={handleSubmit}
          className="w-full bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white py-4 rounded-xl font-bold text-lg shadow-lg active:scale-95 transition-transform"
        >
          إرسال التقييم
        </button>
      </div>
    </div>
  );
}